import { render, staticRenderFns } from "./StudyContent.vue?vue&type=template&id=41462441&scoped=true&"
import script from "./StudyContent.vue?vue&type=script&lang=js&"
export * from "./StudyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41462441",
  null
  
)

export default component.exports